import React from 'react'
import { useSelector } from 'react-redux'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RootState } from '@core/Store'
import { VersionOverrideIndicator } from './DevTools/VersionOverrideIndicator'

/** ONLY to be used within App.tsx */
export const DevTools: React.FC = () => {
  const isReactQueryDevToolsEnabled = useSelector(
    (state: RootState) => state.toolbox.isReactQueryDevToolsEnabled
  )

  return (
    <>
      <VersionOverrideIndicator />
      {isReactQueryDevToolsEnabled && <ReactQueryDevtools initialIsOpen={false} />}
    </>
  )
}
